import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["viewMode", "editMode", "editBtn"]

  connect() {
    if (this.element.querySelector(".field_with_errors, .is-invalid, [aria-invalid='true']")) {
      this.edit()
    }
  }

  edit() {
    this.viewModeTarget.hidden = true
    this.editModeTarget.hidden = false
    this.editBtnTarget.hidden  = true
  }

  cancel() {
    this.viewModeTarget.hidden = false
    this.editModeTarget.hidden = true
    this.editBtnTarget.hidden  = false
  }
}